import { usePartner } from '../../hooks/apollo/use-partner'

const { CLIENT_SEEK_PARTNER_ID, CLIENT_CLOVER_PARTNER_ID, CLIENT_CREDIT_SUITE_PARTNER_ID } = global.process.env

const partnerSettingsDictionary = {
  [CLIENT_SEEK_PARTNER_ID]: [
    'accountDetails',
    'accountDetailsEdit',
    'businesses',
    'financingProfile',
    'security',
    'billingInfo',
    'planDetails',
    'authorizations',
    'logout',
  ],
  [CLIENT_CLOVER_PARTNER_ID]: ['accountDetails', 'businesses', 'authorizations'],
  [CLIENT_CREDIT_SUITE_PARTNER_ID]: ['accountDetails', 'businesses', 'authorizations'],
}

const getPartnerSettings = (partnerId) =>
  partnerSettingsDictionary[partnerId] || ['accountDetails', 'businesses', 'authorizations']

export const usePartnerEnabledSettings = () => {
  const { id: partnerId } = usePartner()

  return {
    partnerHasAccountDetails: () => getPartnerSettings(partnerId).includes('accountDetails'),
    partnerHasAccountDetailsEdit: () => getPartnerSettings(partnerId).includes('accountDetailsEdit'),
    partnerHasBusinesses: () => getPartnerSettings(partnerId).includes('businesses'),
    partnerHasFinancingProfile: () => getPartnerSettings(partnerId).includes('financingProfile'),
    partnerHasSecurity: () => getPartnerSettings(partnerId).includes('security'),
    partnerHasBillingInfo: () => getPartnerSettings(partnerId).includes('billingInfo'),
    partnerHasPlanDetails: () => getPartnerSettings(partnerId).includes('planDetails'),
    partnerHasAuthorizations: () => getPartnerSettings(partnerId).includes('authorizations'),
    partnerHasLogout: () => getPartnerSettings(partnerId).includes('logout'),
  }
}
